import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 询比采购
 * @type {import('@/router').RouteConfig}
 */
export default {
  path: 'inquiry',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '询比采购',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目列表
    {
      path: 'list',
      name: 'ParticipateInquiry',
      component: '/supplier-views/participate/inquiry',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 项目详情
    {
      path: 'orders/:orderId/info',
      name: 'SupplierInquiryDetail',
      component: '/supplier-views/inquiry/inquiry-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 交易详情
    {
      path: 'orders/:orderId/trades/:tradeId?',
      name: 'SupplierInquiryTrade',
      component: '/supplier-views/inquiry/trade/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '交易详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 询比报价
    {
      path: 'orders/:orderId/trades/:tradeId/round/:roundId/:operation',
      name: 'SupplierInquiryQuote',
      component: '/supplier-views/inquiry/trade/quote',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '询比报价',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 变更公告
    {
      path: 'orders/:orderId/changes/detail',
      name: 'SupplierInquiryChangeDetails',
      component: '/supplier-views/inquiry/change/change-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '变更公告',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 线上评审文件
    {
      path: 'orders/:orderId/online-review/file',
      name: 'SupplierInquiryReviewFile',
      component: '/supplier-views/inquiry/online-review/review-file',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '线上评审文件',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
